import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, TextField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'

import type { Schema } from './schema'

export const Form = (): React.JSX.Element => {
  const ability = useAbility()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.general.wrapperBranch',
  })
  const { control } = useFormContext<Schema>()

  const cannotUpdate: boolean = ability.cannot('update', 'GlobalSetupField-newDomainsDefaultBranch')

  return (
    <Paper
      data-cy='section-wrapper-branch'
      variant='cream'
    >
      <BoxForm>
        <SectionHeader
          subtitle={t('subtitle')}
          title={t('title')}
        />

        <TextField
          control={control}
          disabled={cannotUpdate}
          label={t('newDomainsDefaultBranch.label')}
          name='newDomainsDefaultBranch'
        />
      </BoxForm>
    </Paper>
  )
}
